import React from "react";
import SinglePagePDFViewer from "../../../components/pdf/single-page";
import { baseUrl } from "../../../shared/baseUrl";

const ApplicantPDF = ({ data }) => {
  return (
    <div>
      <SinglePagePDFViewer pdf={baseUrl + `/${data?.resume}`} />
    </div>
  );
};

export default ApplicantPDF;
